<template>
  <div class="roting">
    <div class="roting-title">
      {{ menuTitle(data.userRouter) }}
    </div>
    <div
      :class="isSubMenuActive(item) ? 'active' : ''"
      v-for="(item, index) in menuChildren"
      :key="index"
      class="roting-item"
      @click="routerClick(item, index)"
    >
      <el-icon class="iceoc">
        <component :is="item.icon || 'Menu'" />
      </el-icon>
      <span>{{ menuTitle(item) }}</span>
      <span
        v-if="item.name === 'deviceDuplicateRecord' && hasDeviceDuplicate"
        class="red-dot"
      ></span>
    </div>
  </div>
</template>

<script setup>
import { Document, Menu as IconMenu, Location, Setting } from "@element-plus/icons-vue";
import { onMounted, ref, defineProps, reactive, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();
import { useStore } from "@/stores/modules/router.js";
const data = useStore();
const { getNum } = data;
const menuChildren = computed(() => data.userRouter?.children || [])
import { duplicateMonthFlagApi } from "@/api/maintenance/maintenance.js";
import { menuTitle } from "@/utils/menuI18n.js";
import { normalizePath } from "@/utils/pageTitle.js";
const state = reactive({
  num: 0,
});
const props = defineProps({});
const emit = defineEmits(['navigate']);
const hasDeviceDuplicate = ref(false);

onMounted(() => {
  state.num = data.num;
  loadDeviceDuplicateFlag();
});

watch(
  () => route.path,
  () => {
    syncActiveChild()
    loadDeviceDuplicateFlag();
  },
  { immediate: true },
);

const isSubMenuActive = (item) => normalizePath(route.path) === normalizePath(item.path)

const syncActiveChild = () => {
  const current = normalizePath(route.path)
  const idx = menuChildren.value.findIndex((item) => normalizePath(item.path) === current)
  if (idx >= 0) {
    state.num = idx
    getNum(idx)
  }
}

const currentMonth = () => {
  const now = new Date();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  return `${now.getFullYear()}-${m}`;
};

const loadDeviceDuplicateFlag = () => {
  const hasEntry = menuChildren.value.some((i) => i.name === "deviceDuplicateRecord");
  if (!hasEntry) return;
  duplicateMonthFlagApi(JSON.stringify({ month: currentMonth() })).then((res) => {
    hasDeviceDuplicate.value = Boolean(res?.data?.hasDuplicate);
  });
};

const routerClick = (item, index) => {
  router.push(item.path);
  state.num = index;
  getNum(index);
  emit("navigate");
};
</script>

<style lang="less" scoped>
.roting {
  width: 150px;
  height: 100%;
  background-color: transparent;
  margin-right: 0;
  flex-shrink: 0;

  &-title {
    color: #909399;
    padding: 16px 16px 12px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
}

.roting-item {
  height: 36px;
  display: flex;
  align-items: center;
  width: calc(100% - 16px);
  border-radius: var(--admin-radius-sm, 6px);
  margin: 0 8px 4px;
  padding: 0 8px;
  font-size: 13px;
  color: #494949;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
}

.el-icon {
  font-size: 14px !important;
  margin-right: 6px;
  margin-left: 0;
}

.roting-item:hover {
  background-color: #f0f5ff !important;
  color: var(--admin-primary, #409eff);
}

.active {
  background-color: #ecf5ff !important;
  color: var(--admin-primary, #409eff);
  font-weight: 500;
}

.red-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f56c6c;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
